<template>
  <div class="my-2">
    <div class="form-row align-items-center small">
      <div class="col-auto">Total: {{ total }} items</div>
      <div class="col">
        <hr />
      </div>
      <div class="col-auto text-right">
        Sort by:
        <select
          style="background-color: #ebedef; border: none"
          v-model="sortBy"
          @change="sortByChange"
        >
          <option value="UpdatedAt desc">Latest post</option>
          <option value="UpdatedAt asc">Oldest post</option>
          <option value="Votes desc">Highest votes</option>
          <option value="Votes asc">Lowest votes</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
const defaultSortBy = "UpdatedAt desc";
export default {
  props: ["queryObject", "total", "routeName"],
  data() {
    return {
      sortBy: defaultSortBy,
      timeoutQuery: null,
    };
  },
  mounted() {
    this.loadSelectedSorter(this.queryObject);
  },
  watch: {
    queryObject(val) {
      if (this.timeoutQuery) {
        clearTimeout(this.timeoutQuery);
      }
      this.timeoutQuery = setTimeout(() => {
        this.loadSelectedSorter(val);
      }, 500);
    },
  },
  methods: {
    loadSelectedSorter(queryObj) {
      if (queryObj) {
        if (JSON.stringify(queryObj.sortBy) != JSON.stringify(this.sortBy)) {
          this.sortBy = queryObj.sortBy ?? defaultSortBy;
        }
      } else {
        this.sortBy = defaultSortBy;
      }
    },

    sortByChange(e) {
      let query = this.queryObject;
      let routeName = this.routeName;
      query["sortBy"] = e.target.value;
      query["page"] = "1";
      this.$router
        .push({
          name: routeName ?? "Idea",
          query: query,
        })
        .catch(() => {});
    },
  },
};
</script>